import { useEffect, useState } from 'react';
import { NAVY } from './websiteTokens';

// The public website opens in dark (navy) mode for every visitor. The sun/moon switch in the
// nav flips it, and the choice is remembered in this browser across pages and visits.
export const WEBSITE_THEME_KEY = 'ezp_website_theme';
const LIGHT_BG = '#FAFAFA';

function readSaved() {
  try {
    return window.localStorage.getItem(WEBSITE_THEME_KEY);
  } catch {
    return null; // storage blocked (private mode, site data off): start dark
  }
}

export function useWebsiteTheme() {
  const [isDark, setIsDark] = useState(() => readSaved() !== 'light');

  const toggleTheme = () => {
    const next = !isDark;
    setIsDark(next);
    try {
      window.localStorage.setItem(WEBSITE_THEME_KEY, next ? 'dark' : 'light');
    } catch {
      /* not saved; the switch still works for this page */
    }
  };

  // Another open tab changed the theme: follow it.
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === WEBSITE_THEME_KEY) setIsDark(e.newValue !== 'light');
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  // Colour the page behind the content too, so scrolling past the top or bottom
  // doesn't flash white. Restored when leaving the website pages.
  useEffect(() => {
    const body = document.body;
    const prev = body.style.backgroundColor;
    body.style.backgroundColor = isDark ? NAVY.bg : LIGHT_BG;
    return () => {
      body.style.backgroundColor = prev;
    };
  }, [isDark]);

  return { isDark, toggleTheme };
}
